module.exports = __webpack_public_path__ + "img/matoufrance.1a1be977.jpg";